import { defineStore } from 'pinia'
import legalDocumentSectionsService from '../services/legalDocumentSectionsService'
import type { LegalDocumentSection } from '../types'

type State = {
  loaded: boolean
  sections: Record<string, LegalDocumentSection>
}
export const useLegalDocumentTemplateStore = defineStore('legalDocumentTemplate', {
  state: () =>
    ({
      loaded: false,
      sections: {},
    }) as State,
  actions: {
    async fetchData(documentId: string) {
      await legalDocumentSectionsService.fetchAll(documentId).then(legalDocumentSections => {
        this.sections = legalDocumentSections
        this.loaded = true
      })
    },
  },
  getters: {
    find: state => {
      return (code: string) => {
        if (!state.sections) {
          return null
        }
        return state.sections[code]
      }
    },
    optionalSections(): LegalDocumentSection[] {
      if (!this.loaded) {
        return []
      }

      if (!this.sections) {
        return []
      }

      return Object.values(this.sections).filter(section => section.optional_but_selected)
    },
  },
})
